import { PropertyWidget, Widget } from './widget';

export abstract class TextAreaWidget<T extends Widget = Widget>
extends PropertyWidget<T> { }
